function SpacesRepo({ GRAPHQL_URL, httpClient }) {
  this.listSpaces = ({ year }, { success, failure }) => {
    const query = `query ($year: Int!) {
                    listSpaces(
                      spaceSearch: {
                        year: $year
                      })
                      {
                        data {
                          element1
                          element2
                          element3
                          element4
                          year
                          updatedTimeStamp
                          estimates {
                            accountId
                            environment
                            accountDescription
                            accountName
                            status
                            allocation {
                              percentage
                              startDate
                              insertedDate
                              endDate
                              environment
                            }
                            breakdown {
                              total
                              startDate
                              endDate
                              estimateLink
                              reference
                            }
                          }
                        }
                        error {
                          code
                          message
                          statusCode
                        }
                      }
                    }
`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year
          }
        }
      },
      {
        success: (response) => {
          const { listSpaces } = response.data.data
          success(listSpaces)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.createOrUpdateSpace = ({ year, element1, element2, element3, element4, estimates }, { success, failure }) => {
    const query = `mutation ($year: Int!, $estimates: [EstimatesInput]!, $element1Id: String!, $element2Id: String!, $element3Id: String!, $element4Id: String!) {
              createOrUpdateSpaceDetails(space: {estimates: $estimates, element1Id: $element1Id, element2Id: $element2Id, element3Id: $element3Id, element4Id: $element4Id, year: $year}) {
                data
                error {
                  code
                  message
                  statusCode
                }
              }
          }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year,
            element1Id: element1,
            element2Id: element2,
            element3Id: element3,
            element4Id: element4,
            estimates
          }
        }
      },
      {
        success: (response) => {
          if (response.data.errors) {
            failure(response.data.errors)
            return
          }
          const { createOrUpdateSpaceDetails } = response.data.data
          success(createOrUpdateSpaceDetails)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.listResources = ({ searchParams }, { success, failure }) => {
    const query = `
      query($searchParams: ListResourceInput!) {
        listResources(
          searchParams: $searchParams
        )
        {
          data {
            accountId
            claimedStatus {
              id
              claimedBy
              elementMap {
                element1Id
                element2Id
                element3Id
                element4Id
              }
              reference
              startDate
            }
            creationDate
            region
            resourceId
            productCode
            tags {
              key
              value
            }
          }
          error {
            code
            message
            statusCode
          }
        }
      }
    `
    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        timeout: 30000,
        data: {
          query,
          variables: {
            searchParams
          }
        }
      },
      {
        success: (response) => {
          const { data, errors } = response.data
          if (errors) {
            failure(errors)
            return
          }
          const { listResources } = data
          success(listResources)
        },
        failure: (error) => failure(error)
      }
    )
  }

  this.claimResource = ({ accountId, resources }, { success, failure }) => {
    const query = `
      mutation claimResourceMutation(
        $accountId: String!,
        $resources: [ClaimResourceBreakdown]!
      ) {
        claimResource(
          accountId: $accountId,
          resources: $resources
        ) {
          data {
            resourceId
            status
          }
          error {
            code
            message
            statusCode
          }
        }
      }
    `
    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            accountId,
            resources
          }
        }
      },
      {
        success: (response) => {
          const { data, errors } = response.data
          if (errors) {
            failure(errors)
            return
          }
          const { claimResource } = data
          success(claimResource)
        },
        failure: (error) => {
          failure(error)
        }
      }
    )
  }

  this.releaseResource = ({ accountId, resources }, { success, failure }) => {
    const query = `
      mutation releaseResourceMutation(
        $accountId: String!,
        $resources: [ReleaseResourceBreakdown]!
      ) {
        releaseResource(
          accountId: $accountId,
          resources: $resources
        ) {
          data {
            id
            resourceId
            status
          }
          error {
            code
            message
            statusCode
          }
        }
      }
    `

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            accountId,
            resources
          }
        }
      },
      {
        success: (response) => {
          const { releaseResource } = response.data.data
          const { data, error } = releaseResource

          if (error) {
            failure(error)
            return
          }

          success(data)
        },
        failure: (error) => {
          failure(error)
        }
      }
    )
  }

  this.getResourceLaunchData = ({ accountId, resourceIds }, { success, failure }) => {
    const query = `
      query ($accountId: String!, $resourceIds: [String]!) {
        getResourceLaunchData(accountId: $accountId, resourceIds: $resourceIds) {
          data {
            accountId
            launchDate
            resourceId
          }
          error {
            code
            message
            statusCode
          }
        }
      }
    `

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            accountId,
            resourceIds
          }
        }
      },
      {
        success: (response) => {
          const { getResourceLaunchData } = response.data.data
          const { data, error } = getResourceLaunchData

          if (error) {
            failure(error)
            return
          }

          success(data)
        },
        failure: (error) => {
          failure(error)
        }
      }
    )
  }
}

export default SpacesRepo
